<template>
  <el-container style="height: 100vh;">
    <el-header class="header">
      <div class="header-left">
        <span class="system-name">收银数据集成系统</span>
      </div>
      <div class="header-right">
        <el-dropdown>
      <span class="user-info">
        <!-- 核心：优先显示用户头像 → 无头像显示默认User图标 -->
<!--        <el-avatar-->
<!--            v-if="userStore.userInfo?.avatarUrl"-->
<!--            :src="userStore.userInfo?.avatarUrl"-->
<!--            :size="20"-->
<!--            class="avatar-img"-->
<!--            shape="square"-->
<!--        />-->
<!--        <el-icon v-else><User/></el-icon>-->
         <el-icon ><User/></el-icon>
        {{ userStore.userInfo?.username || '用户' }}
      </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="handleEditPwd">修改密码</el-dropdown-item>
              <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-header>

    <el-container>
      <el-aside class="aside" style="width: 180px;">
        <el-menu
            :default-active="activeIndex"
            :open-names="openNames"
            class="menu"
            :active-text-color="'#fdfeff'"
            :background-color="'#4f5d71'"
            text-color="#fff"
            unique-opened
        >
          <template v-for="item in menuList" :key="item.index">
            <el-sub-menu v-if="item.children && item.children.length" :index="item.index">
              <template #title>
                <el-icon>
                  <component :is="item.icon"/>
                </el-icon>
                <span>{{ item.label }}</span>
              </template>
              <el-menu-item
                  class="menu_item"
                  v-for="child in item.children"
                  :key="child.index"
                  :index="child.index"
                  @click="handleMenuClick(child)"
              >
                <el-icon>
                  <component :is="child.icon"/>
                </el-icon>
                <span>{{ child.label }}</span>
              </el-menu-item>
            </el-sub-menu>

            <el-menu-item v-else :index="item.index" @click="handleMenuClick(item)">
              <el-icon>
                <component :is="item.icon"/>
              </el-icon>
              <span>{{ item.label }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>

      <el-main class="main">
        <div class="custom-tabs" v-if="tabList.length > 0">
          <div class="tabs-nav">
            <div
                class="tab-item"
                v-for="tab in tabList"
                :key="tab.path"
                :class="{ active: activeTabPath === tab.path }"
                @click="handleTabClick({props:{name:tab.path}})"
            >
              <span class="tab-title">{{ tab.title }}</span>
              <span
                  class="tab-close"
                  @click.stop="handleTabClose(tab.path)"
              >✕</span>
            </div>
          </div>
        </div>
        <router-view></router-view>
      </el-main>

      <!-- 修改密码弹窗 -->
      <el-dialog
          v-model="pwdDialogVisible"
          title="修改用户密码"
          width="400px"
          @close="resetPwdForm"
      >
        <el-form
            v-loading="loading"
            ref="pwdFormRef"
            :model="pwdForm"
            :rules="pwdFormRules"
            label-width="100px"
            style="margin-top: 16px"
        >
          <el-form-item label="新密码" prop="newPassword">
            <el-input
                v-model="pwdForm.newPassword"
                type="password"
                placeholder="请输入新密码"
                show-password
            />
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPassword">
            <el-input
                v-model="pwdForm.confirmPassword"
                type="password"
                placeholder="请再次输入新密码"
                show-password
            />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="pwdDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitEditPwd">确认修改</el-button>
        </template>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script setup lang="ts">
import {reactive, ref, watch} from "vue";
import {useRouter, useRoute} from "vue-router";
import {User} from "@element-plus/icons-vue";
import {useUserStore} from "@/stores/user";
import {ElMessage, ElMessageBox, FormInstance, FormRules} from "element-plus";
import {PwdForm} from "@/types/common";
import {userApi} from "@/api";
import {handleApiError} from "@/utils/error";
import {useKingdeeStore} from "@/stores/kingdeeStroe";
const kingdeeStore = useKingdeeStore();
const userStore = useUserStore();

// 菜单数据接口
interface MenuItem {
  index: string;
  label: string;
  icon: string;
  path?: string;
  children?: MenuItem[];
}

// 标签页数据接口
interface TabItem {
  path: string;
  title: string;
}

const router = useRouter();
const route = useRoute();

const menuList: MenuItem[] = [
  {
    index: "1",
    label: "首页",
    icon: "HomeFilled",
    path: "/index/home",
  },
  {
    index: "2",
    label: "财务会计",
    icon: "Edit",
    children: [
      {index: "2-1", label: "出纳管理", icon: "Menu", path: "/index/finc-account/cashier-manage/index"},
    ],
  },
  {
    index: "3",
    label: "供应链",
    icon: "Share",
    children: [
      {index: "3-1", label: "销售管理", icon: "Menu", path: "/index/supply-chain/sales-manage/index"},
      {index: "3-2", label: "采购管理", icon: "Menu", path: "/index/supply-chain/purchases-manage/index"},
    ],
  },
  {
    index: "4",
    label: "基础管理",
    icon: "Postcard",
    children: [
      {index: "4-1", label: "基础资料", icon: "Menu", path: "/index/basic-manage/basic-Information/index"},
    ],
  },
  {
    index: "10",
    label: "系统",
    icon: "Setting",
    children: [
      {index: "10-1", label: "菜单", icon: "Menu", path: "/index/system/index"},
    ],
  },
];

const loading = ref<boolean>(false)
const openNames = ref<string[]>([]);
const activeIndex = ref("1");
const tabList = ref<TabItem[]>([]);
const activeTabPath = ref("");

const isNeedTab = (path: string) => {
  return path.includes('/index/') && path !== '/index/home' && !path.endsWith('/index');
};

const moduleBackUrl = {
  '/index/system/': '/index/system/index',   // 系统模块子项 → 回系统菜单页
  '/index/supply-chain/sales-manage/': '/index/supply-chain/sales-manage/index',   // 业务模块子项 → 回业务菜单页 销售管理
  '/index/finc-account/cashier-manage/': '/index/finc-account/cashier-manage/index',  // 出纳管理
  '/index/supply-chain/purchases-manage/': '/index/supply-chain/purchases-manage/index', // 采购管理
  '/index/basic-manage/basic-Information/': '/index/basic-manage/basic-Information/index' // 基础管理
};

const handleMenuClick = (item: MenuItem) => {
  if (item.path) {
    router.push(item.path);
  }
};

watch(
    () => route.path,
    (newPath) => {
      const findActive = (list: MenuItem[], parentIndex?: string): { activeIndex: string; parentIndex?: string } => {
        for (const item of list) {
          if (item.path === newPath) {
            return { activeIndex: item.index, parentIndex };
          }
          if (item.children && item.children.length > 0) {
            const result = findActive(item.children, item.index);
            if (result.activeIndex) {
              return result;
            }
          }
        }
        return { activeIndex: "" };
      };

      const { activeIndex: idx, parentIndex } = findActive(menuList);
      activeIndex.value = idx;
      if (parentIndex) {
        openNames.value = [parentIndex];
      } else {
        openNames.value = [];
      }

      // 生成标签页
      if (isNeedTab(newPath)) {
        const pageTitle = route.meta.title as string || '未知页面';
        const isTabExist = tabList.value.some(tab => tab.path === newPath);
        if (isTabExist) {
          activeTabPath.value = newPath;
          return;
        }
        tabList.value.push({ path: newPath, title: pageTitle });
        activeTabPath.value = newPath;
      }
    },
    { immediate: true }
);

// 修改密码弹窗相关
const pwdDialogVisible = ref<boolean>(false) // 弹窗显示状态
const currentEditUserId = ref<number>(0) // 当前要修改密码的用户ID
const pwdFormRef = ref<FormInstance>() // 表单引用
// 密码表单数据
const pwdForm = reactive<PwdForm>({
  newPassword: '',
  confirmPassword: ''
})
// 密码表单校验规则
const pwdFormRules = reactive<FormRules>({
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' } // 可根据实际需求调整密码规则
  ],
  confirmPassword: [
    { required: true, message: '请确认新密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== pwdForm.newPassword) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ]
})

// 操作按钮-修改密码
const handleEditPwd = () => {
  // 记录当前要修改密码的用户ID
  currentEditUserId.value = userStore.userInfo.userId;
  // 重置表单
  resetPwdForm();
  // 打开弹窗
  pwdDialogVisible.value = true;
}

// 重置密码表单
const resetPwdForm = () => {
  if (pwdFormRef.value) {
    pwdFormRef.value.resetFields();
  }
  // 清空表单数据
  pwdForm.newPassword = '';
  pwdForm.confirmPassword = '';
}

// 提交修改密码
const submitEditPwd = async () => {
  if (!pwdFormRef.value) return;

  try {
    // 表单校验
    await pwdFormRef.value.validate();
    // 二次确认（可选，增加操作安全性）
    await ElMessageBox.confirm(
        '确定要修改该用户的密码吗？',
        '温馨提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
    );
    loading.value = true;
    // 调用修改密码接口（请根据实际接口调整参数）
    const request = {
      userId:currentEditUserId.value,
      newPassword:pwdForm.newPassword
    }
    await userApi.updateUserPassword(request);
    ElMessage.success('密码修改成功！');
    // 关闭弹窗
    pwdDialogVisible.value = false;
  } catch (error) {
    // 表单校验失败或用户取消操作时不提示错误
    if (error !== 'cancel' && !(error instanceof Error && error.message.includes('Validation failed'))) {
      handleApiError(error);
    }
  } finally {
    loading.value = false;
  }
}

// 标签页切换
const handleTabClick = (tab: any) => {
  router.push(tab.props.name);
};

//关闭标签逻辑
const handleTabClose = (path: string) => {
  const tabIndex = tabList.value.findIndex(tab => tab.path === path);
  tabList.value.splice(tabIndex, 1);

  if (path === activeTabPath.value) {
    const newActiveTab = tabList.value[tabIndex - 1] || tabList.value[0];
    // 如果还有标签，正常切换
    if (newActiveTab) {
      activeTabPath.value = newActiveTab.path;
      router.push(newActiveTab.path);
    } else {
      // 没有标签了 → 动态匹配当前路径所属的模块，回退到对应菜单页
      activeTabPath.value = "";
      let backUrl = "";
      for (const key in moduleBackUrl) {
        if (path.includes(key)) {
          kingdeeStore.clearPageNumber();
          backUrl = moduleBackUrl[key as keyof typeof moduleBackUrl];
          break;
        }
      }
      router.push(backUrl);
    }
  }
};

// 退出登录
const logout = () => {
  userStore.clearToken();
  ElMessage.success("退出登录成功！");
  router.push("/login");
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.header {
  background: #4c5c73;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-right {
  margin-right: 60px;
}

.system-name {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffffff;
  cursor: pointer;
}

.user-info:focus {
  outline: none;
}

.avatar-img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}

.aside {
  height: 100%;
}

.menu {
  height: 100%;
  border-right: none;
}

.menu_item {
  background-color: #5a7291
}

.menu_item:hover {
  background-color: #acb3bc
}

.main {
  background: linear-gradient(to bottom, #ecf1fa 0%, #e7f1fb 100%) no-repeat;
  padding: 20px;
  overflow-y: auto;
  height: calc(100vh - 60px);
}

.custom-tabs {
  width: 100%;
  margin-bottom: 20px;
  border-bottom: 2px solid #000000;
}
.tabs-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 4px;
  /* 隐藏滚动条但保留滚动功能 */
  scrollbar-width: none;
}
.tabs-nav::-webkit-scrollbar {
  display: none;
}
.tab-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: #f5f7fa;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}
/* 标签激活态 */
.tab-item.active {
  background-color: #4f5d71;
  color: #fff;
}
/* 标签悬浮态 */
.tab-item:hover:not(.active) {
  background-color: #eef2f7;
  border-color: #dde3eb;
}
.tab-title {
  font-size: 14px;
  margin-right: 8px;
}
.tab-close {
  font-size: 12px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #999;
}
.tab-close:hover {
  color: #ff4d4f;
  background-color: #fef0f0;
}
/* 激活态的关闭按钮样式 */
.tab-item.active .tab-close {
  color: #fff;
}
.tab-item.active:hover .tab-close {
  background-color: rgba(255,255,255,0.2);
}
</style>